document.addEventListener("DOMContentLoaded", function() {
  const counters = document.querySelectorAll(".count");
  const speed = 100; // quanto menor, mais rápido

  const animateCount = (counter) => {
    const target = +counter.getAttribute("data-target");
    const updateCount = () => {
      const current = +counter.innerText.replace(/\./g, '');
      const increment = Math.ceil(target / speed);

      if (current < target) {
        counter.innerText = (current + increment).toLocaleString('pt-BR');
        requestAnimationFrame(updateCount);
      } else {
        counter.innerText = target.toLocaleString('pt-BR');
      }
    };
    updateCount();
  };

  // Detecta quando a seção entra na tela
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll(".count").forEach(animateCount);
        observer.unobserve(entry.target); // roda só uma vez
      }
    });
  }, { threshold: 0.4 });

  const section = document.querySelector("#home-about");
  if (section) observer.observe(section);
});